import {createContext, memo, use, useMemo} from 'react'

import {useHandlePaginatedDataRefresh} from '../../data-refresh/use-handle-paginated-data-refresh'

type PaginatedMemexItemsQueryContextType = {
  handlePaginatedDataRefresh: ReturnType<typeof useHandlePaginatedDataRefresh>['handleRefresh']
  issueDeletionTargets: ReturnType<typeof useHandlePaginatedDataRefresh>['issueDeletionTargets']
  getIssueDeletionTargets: ReturnType<typeof useHandlePaginatedDataRefresh>['getIssueDeletionTargets']
  refreshForIssueDeletion: ReturnType<typeof useHandlePaginatedDataRefresh>['refreshForIssueDeletion']
  isRefreshing: boolean
}

const PaginatedMemexItemsQueryContext = createContext<PaginatedMemexItemsQueryContextType | null>(null)

export const PaginatedMemexItemsQueryProvider = memo(function PaginatedMemexItemsQueryProviderComponent({
  children,
}: {
  children: React.ReactNode
}) {
  const {
    handleRefresh: handlePaginatedDataRefresh,
    isRefreshing,
    issueDeletionTargets,
    getIssueDeletionTargets,
    refreshForIssueDeletion,
  } = useHandlePaginatedDataRefresh()

  const value = useMemo(() => {
    // eslint-disable-next-line @github-ui/github-monorepo/no-mixed-stability-context-value -- deletion targets must update with the provider's current loaded query set
    return {
      handlePaginatedDataRefresh,
      isRefreshing,
      issueDeletionTargets,
      getIssueDeletionTargets,
      refreshForIssueDeletion,
    }
  }, [getIssueDeletionTargets, handlePaginatedDataRefresh, isRefreshing, issueDeletionTargets, refreshForIssueDeletion])

  return <PaginatedMemexItemsQueryContext value={value}>{children}</PaginatedMemexItemsQueryContext>
})

export const usePaginatedMemexItemsQueryContext = () => use(PaginatedMemexItemsQueryContext)
